import { IGroupFixture } from "core-integration/src/store/fixtures/types";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
import { Tab, TabList, TabPanel, TabsWrapper } from "../../Tabs";
import { MatchStats } from "./MatchStats";
import { PlayerStats } from "./PlayerStats";

interface FixtureStatsProps {
  fixture: IGroupFixture;
}

const FixtureStats = ({ fixture }: FixtureStatsProps) => {
  const { statsAbbreviation, matchDetails, playerStats } =
    usePlosTranslations();
  return (
    <TabsWrapper>
      <TabList aria-label={statsAbbreviation}>
        <Tab id="match">{matchDetails}</Tab>
        <Tab id="players">{playerStats}</Tab>
      </TabList>
      <TabPanel id="match">
        <MatchStats fixture={fixture} />
      </TabPanel>
      <TabPanel id="players">
        <PlayerStats fixture={fixture} />
      </TabPanel>
    </TabsWrapper>
  );
};

export default FixtureStats;
